/**
 * Where an authenticated user belongs.
 *
 * This logic was duplicated as a hardcoded role list in four places
 * (LogoOnlyLayout, websiteLayout, UserLayout, Page404). Each ended in an `else`
 * that sent anything unrecognised to a learner route (/auth/subscribe or
 * /auth/my-courses). Those routes do not exist outside the learner route trees,
 * so a role like MARKETING_USER was bounced to CheckRoute, back to /login, and
 * straight into the same effect again - an infinite redirect loop that fired
 * hundreds of requests a second.
 *
 * Single source of truth now, driven by role_lk.default_route / role_lk.layout
 * delivered on /authenticate/loginInfo, so a new role is correct everywhere
 * without touching any layout.
 */

// Fallback when a role has no default_route stored yet.
const LAYOUT_LANDING = {
  ADMIN: '/app/dashboard',
  CLIENT: '/app/dashboard',
  CONTENT: '/app/course',
  USER: '/app/course',
  DIRECT_USER: '/auth/subscribe',
};

// Final fallback for sessions issued before layout shipped.
const LEGACY_ROLE_LANDING = {
  SUPER_ADMIN: '/app/dashboard',
  CLIENT_ADMIN: '/app/dashboard',
  MANAGER: '/app/dashboard',
  CONTENT_WRITER: '/app/course',
  AUTH_USER: '/app/course',
  USER_DTC: '/auth/subscribe',
};

/**
 * @param {object} userInfo redux state.userInfo
 * @returns {string|null} path to send the user to, or null when unknown.
 *   null means "leave them where they are" - never guess a learner route for a
 *   role we cannot place, because that is what caused the redirect loop.
 */
export function resolveLandingRoute(userInfo) {
  if (!userInfo) return null;
  return (
    userInfo.defaultRoute
    || LAYOUT_LANDING[userInfo.layout]
    || LEGACY_ROLE_LANDING[userInfo.role]
    || null
  );
}

export default resolveLandingRoute;
